
export default ({
  name: 'TriangleImages',
  components: {
  },
  props: {}
})
